// The option lists for a property listing. One source of truth shared by the "list a property"
// form (pages/PropertyForm.js) and the browse-page filters (pages/ItemList.js) - kept in a plain
// module (no React / api imports) so the customer-facing browse bundle doesn't pull the whole
// form in. Amenities are free text on the form, so the filter offers the common ones.
export const PROPERTY_CATEGORIES = ['Apartment', 'Penthouse', 'Villa', 'Independent House', 'Commercial'];
export const PROPERTY_AMENITIES = ['Parking', 'Lift', 'Gym', 'Swimming Pool', 'Power Backup', 'Security', 'Club House', 'Park', 'Gated Community'];
